import ArticleCard, {IArticleCard} from "../../ui/articlecard/articlecard";
import SearchIcon from '@mui/icons-material/Search';
import "../styles/articles.scss";
import {useState} from "react";

const Articles = () => {
    const [search, setSearch] = useState("");
    const articleItems:IArticleCard[] = [
        {image:require("../../assets/images/photos/ArticleImage2.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage3.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage1.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage1.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage2.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage4.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage3.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage4.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
        {image:require("../../assets/images/photos/ArticleImage1.png") , text: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید" , link: ""},
    ]
    return (
        <div className="Articles">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                        <div className="row">
                            <div className="col-12 mb-4">
                                <div className="Article-Side-Container">
                                    <h5 className="pb-3">جستجو</h5>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <input type="text" placeholder={"کلمه مورد نظر"} onChange={e => {
                                            setSearch(e.target.value)
                                        }} name="number" id="" className="Information-Input"/>
                                        <button className="Search-Button">
                                            <SearchIcon />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="Article-Side-Container">
                                    <h5 className="pb-3">دسته بندی ها</h5>
                                    <p>نام دسته شماره یک</p>
                                    <p>نام دسته شماره دو</p>
                                    <p>نام دسته شماره سه</p>
                                    <p>نام دسته شماره چهار</p>
                                    <p>نام دسته شماره پنج</p>
                                    <p>نام دسته شماره شش</p>
                                    <p>نام دسته شماره هفت</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-8 col-sm-6 col-12 mb-3">
                        <div className="row">
                            {
                                articleItems.map((articleItem,index) => {
                                    return(
                                        <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                                            <ArticleCard image={articleItem.image} text={articleItem.text} link={articleItem.link} />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Articles;